﻿import {
  GET_APPOINTMENTS,
  GET_APPOINTMENTS_ERROR,
  GET_APPOINTMENTS_SUCCESS,
} from '../actions/actionTypes';

const INITIAL_STATE = {
  isFetching: false,
  appointments: null,
};

const appointments = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_APPOINTMENTS:
      return {
        ...state,
        isFetching: true,
      };
    case GET_APPOINTMENTS_ERROR:
      return {
        ...state,
        isFetching: false,
        appointments: []
      };
    case GET_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        appointments: action.appointments,
      };
    default:
      return state;
  }
};

export default appointments;
